import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SeoService } from '../service/seo.service';
import { GlobalComponent } from '../global/global.component';

@Component({
  selector: 'app-machining',
  templateUrl: './machining.component.html',
  styleUrls: ['./machining.component.scss']
})
export class MachiningComponent implements OnInit {

  constructor(private SEOService:SeoService,private router: Router) {   window.scroll(0, 0);}
hostName = GlobalComponent.hostName;
  ngOnInit(): void {
    
    this.SEOService.updateCanonicalUrl(this.hostName + '/machining');
  }

  signup()
    {
      this.router.navigate(['/login/signup']);

    }
 

}
